import React, { useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { Button } from "@mui/material";
import logo from "../../assets/images/lovebiglogo.png";
import { userContext } from "../../Context";

import "./styles.css";
export default function NavBar() {
  const { isAuthenticated, setIsAuthenticated, setUser } =
    useContext(userContext);

  const history = useHistory();

  const [click, setClick] = useState(false);

  async function logout() {
    let store = JSON.parse(localStorage.getItem("login"));

    if (store && store.token) {
      removeStorage();
      setUser({
        firstName: "",
        lastName: "",
        email: "",
        id: "",
        partnerId: "",
        role: "",
      });
      history.push("/");
    }
  }

  function removeStorage() {
    localStorage.removeItem("login");
    setIsAuthenticated(false);
  }

  const handleClick = () => {
    if (!click) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
    setClick(!click);
  };

  return (
    <>
      {/* After 768px */}
      <div className="nav-bar-large">
        <Link to="/">
          {" "}
          <img src={logo} alt="Love Big" className="navbar-logo"></img>
        </Link>
        <div className="nav-buttons">
          <Link to="/" className="nav-button">
            HOME
          </Link>

          <Link to="/about" className="nav-button">
            ABOUT
          </Link>
          <Link to="/explore" className="nav-button">
            EXPLORE PROJECTS
          </Link>
          <Link to="/partners" className="nav-button">
            PARTNERS
          </Link>
          <div className="login-options">
            {!isAuthenticated ? (
              <>
                <Link to="/login" className="button header-login-btn">
                  User Login
                </Link>
                <Link to="/join" className="button header-signup-btn">
                  Create an Account
                </Link>{" "}
              </>
            ) : (
              <>
                <Link to="/profile" className="view-profile-button">
                  <Button variant="contained" color="light" size="small">
                    View Profile
                  </Button>
                </Link>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => logout()}
                  size="small"
                >
                  Logout
                </Button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Before 768px */}
      <div className="nav-bar">
        <Link to="/">
          {" "}
          <img src={logo} alt="Love Big" className="navbar-logo"></img>
        </Link>
        <div
          className={click ? "menu-icon active" : "menu-icon"}
          onClick={handleClick}
        >
          <i className={click ? "fas fa-times" : "fas fa-bars"}></i>
        </div>
        <ul className={click ? "nav-menu active" : "nav-menu"}>
          <div className="nav-list">
            <Link to="/" className="nav-item" onClick={handleClick}>
              Home
            </Link>
            <Link to="/about" className="nav-item" onClick={handleClick}>
              About
            </Link>
            <Link to="/explore" className="nav-item" onClick={handleClick}>
              Explore Projects
            </Link>
            <Link to="/partners" className="nav-item" onClick={handleClick}>
              Partners
            </Link>
          </div>
          <div className="login-options">
            {isAuthenticated ? (
              <>
                <Button variant="contained" color="light" size="small">
                  <Link to="/profile" onClick={handleClick} className="link">
                    View Profile
                  </Link>
                </Button>

                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    handleClick();
                    logout();
                  }}
                  size="small"
                >
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="button header-login-btn"
                  onClick={handleClick}
                >
                  User Login
                </Link>
                <Link
                  to="/join"
                  className="button header-signup-btn"
                  onClick={handleClick}
                >
                  Create an Account
                </Link>
              </>
            )}
          </div>
        </ul>
      </div>
    </>
  );
}
